import { Grid, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/StoreContextProvider';
import pas_logo from '../../../assets/image/pas_logo.svg';

function HeaderTitle() {
  const { headerStore } = useRootStore();
  return (
    <>
      <Grid container alignItems='center'>
        <img src={pas_logo} alt='logo' width={24} height={24} style={{ marginRight: 5 }} />

        <Typography
          sx={{
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '24px',
          }}
        >
          {headerStore.pageTitle}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '12px',
            marginLeft: '8px',
            color: '#999999',
          }}
        >
          {headerStore.pageSubTitle}
        </Typography>
      </Grid>
    </>
  );
}

export default observer(HeaderTitle);
